import boxShadows from "../../theme/box-shadow";

const componentStyles = (theme) => ({
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "39px",
      paddingRight: "39px",
    },
  },
  gridItemRoot: {
    [theme.breakpoints.up("xl")]: {
      marginBottom: "0!important",
    },
  },
  cardRoot: {
    boxShadow: boxShadows.boxShadow + "!important",
  },
  cardHeader: {
    backgroundColor: "initial",
  },
  buttonDelete: {
    color: theme.palette.white.main,
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
      borderColor: theme.palette.error.dark,
    },
  },
  detailCardRoot: {
    marginBottom: "1.5rem",
    backgroundColor: theme.palette.gray[100],
  },
  loadingWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  customBoxWrapper: {
    position: "relative",
  },
});

export default componentStyles;
